import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 60000
});

const TOKEN_KEY = 'chat_auth_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      setToken(null);
      if (window.location.pathname.startsWith('/chat')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
